import { makeStyles } from "@material-ui/core";


export const resultStyles = makeStyles((theme) => ({
    item: {
        "& em": {
            color: theme.palette.secondary.main,
            fontStyle: "normal",
            fontWeight: 700,
        },
        "&:hover": {
            "& .MuiListItemSecondaryAction-root": {
                visibility: "visible",
            },
        },
        "& .MuiListItemSecondaryAction-root": {
            visibility: "hidden",
        },
    },
    title: {
        maxWidth: 460,
        fontWeight: 700,
    },
    subheader: {
        maxWidth: 460,
        textOverflow: "ellipsis",
    },
}));
